import { useCallback, useEffect, useMemo } from 'react'
import API from '../services/api'
import { useAPIRequestRunner } from './useAPIRequest'

export const useEvent = (eventId: string) => {
  const {
    state: { inProgress, data, error },
    run,
  } = useAPIRequestRunner<API.EventResponse>()

  const doApiRequest = useCallback(() => 
    run(API.getEvent(eventId))
  , [eventId, run])

  useEffect(() => {
    doApiRequest()
  }, [doApiRequest])

  return useMemo(
    () => ({
      inProgress,
      data,
      error,
      refresh: doApiRequest,
    }),
    [inProgress, data, error, doApiRequest]
  )
}
